import jQuery from "jquery";
import 'bootstrap/js/dist/modal';
import {ACTION, Events} from "../events";
import NewsletterForm from "./forms/newsletter";

jQuery(document).ready(function ($) {

    let newsletterModal = {

        $newsletterModal: $('#newsletter-modal'),
        form: {},

        init: function () {
            this.initListeners();
            // this.form.init();
            this.form = new NewsletterForm(this.$newsletterModal);
            this.form.init();
        },
        toggleDisplay: function () {
            if (this.$newsletterModal[0].attributes['aria-hidden'].value === "true") {
                this.showModal();
                this.form.reset();
            } else {
                this.hideModal();
            }
        },
        initListeners: function () {
            Events.on(ACTION.TOGGLE_NEWSLETTER_MODAL, this.toggleDisplay, this)
        },

        showModal: function () {
            this.$newsletterModal.modal("show");
        },

        hideModal: function () {
            this.$newsletterModal.modal("hide");
        }

    }

    newsletterModal.init();
});
